// BRAIN ROT PAGE - Screen Time Tracker
export const brainRotContent = {
  pageMaxWidth: '1200px',
  breadcrumb: {
    text: 'Back to Home',
    url: '/'
  },

  sections: [
    // HERO SECTION
    {
      id: 'hero',
      spacing: 'clamp(32px, 5vw, 64px)',
      blocks: [
        {
          type: 'container',
          narrow: true,
          blocks: [
            {
              type: 'custom',
              render: () => (
                <span style={{
                  background: 'linear-gradient(135deg, #FF6B6B 0%, #8B4513 100%)',
                  color: 'white',
                  padding: '8px 20px',
                  borderRadius: '25px',
                  fontSize: '13px',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  display: 'inline-block'
                }}>
                  Mobile Apps
                </span>
              )
            }
          ]
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'title',
          text: 'Brain Rot',
          size: 'h1'
        },
        {
          type: 'text',
          content: 'Track your screen time with a fun, visual brain health indicator',
          size: 'large',
          align: 'left'
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'text',
          content: 'A playful screen time tracker that visualizes your digital consumption through an animated brain that shows your "rot level" based on daily usage.'
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'custom',
          render: () => (
            <div style={{
              display: 'flex',
              gap: '16px',
              flexWrap: 'wrap'
            }}>
              <span style={{
                background: 'linear-gradient(135deg, #FF6B6B 0%, #8B4513 100%)',
                color: 'white',
                padding: '12px 24px',
                borderRadius: '8px',
                fontWeight: '600'
              }}>
                Completed
              </span>
            </div>
          )
        }
      ]
    },

    // CONCEPT
    {
      id: 'concept',
      title: 'The Concept',
      blocks: [
        {
          type: 'container',
          background: true,
          blocks: [
            {
              type: 'text',
              content: 'Brain Rot takes a humorous approach to screen time awareness. Instead of showing boring statistics, it visualizes your usage through an animated brain character that progressively "rots" as your screen time increases throughout the day.'
            },
            { type: 'spacer', size: 'small' },
            {
              type: 'text',
              content: 'The visual feedback makes it easier to understand the impact of excessive screen time while keeping the experience fun and engaging rather than guilt-inducing.'
            }
          ]
        }
      ]
    },

    // FEATURES
    {
      id: 'features',
      title: 'Features',
      blocks: [
        {
          type: 'custom',
          render: () => (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '24px'
            }}>
              {[
                { icon: '🧠', title: 'Animated Brain', desc: 'SVG brain that changes color based on usage level' },
                { icon: '📊', title: 'Usage Calendar', desc: 'GitHub-style heatmap showing daily patterns' },
                { icon: '⏱️', title: 'Real-time Tracking', desc: 'Live updates on your current session' },
                { icon: '🎨', title: 'Visual Feedback', desc: 'Color-coded rot levels from healthy pink to brown' }
              ].map((feature, i) => (
                <div key={i} style={{
                  background: 'var(--bg-secondary)',
                  padding: '24px',
                  borderRadius: '16px',
                  border: '1px solid var(--border-color)'
                }}>
                  <div style={{ fontSize: '2rem', marginBottom: '12px' }}>{feature.icon}</div>
                  <h3 style={{ color: 'var(--text-primary)', marginBottom: '8px', fontSize: '1.1rem' }}>{feature.title}</h3>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '0.95rem', margin: 0 }}>{feature.desc}</p>
                </div>
              ))}
            </div>
          )
        }
      ]
    },

    // TECH STACK
    {
      id: 'tech',
      title: 'Built With',
      blocks: [
        {
          type: 'custom',
          render: () => (
            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '12px'
            }}>
              {['React Native', 'Expo', 'AsyncStorage', 'SVG Animation', 'TypeScript'].map((tech, i) => (
                <span key={i} style={{
                  background: 'var(--bg-secondary)',
                  color: 'var(--text-primary)',
                  padding: '10px 20px',
                  borderRadius: '25px',
                  fontSize: '0.9rem',
                  border: '1px solid var(--border-color)'
                }}>
                  {tech}
                </span>
              ))}
            </div>
          )
        }
      ]
    }
  ],

  callToAction: {
    title: 'Brain Rot',
    text: 'A fun way to be mindful of screen time',
    button: {
      text: 'See more work →',
      url: '/'
    }
  }
};
